import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getSettingOwFGrantMoney } from "@faire/retailer-visitor-shared/settings/getSettingOwFGrantMoney";
import { OwFGrantApplicationSteps } from "@faire/retailer-visitor-shared/views/owf-small-business-grant/application-page/types";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { formatMoney, RoundingStrategy } from "@faire/web--source/common/money";
import { Button } from "@faire/web--source/slate/Button";
import { Row, Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { route as smallBusinessGrantTosRoute } from "@faire/web-api--source/routes/small-business-grant/tos";
import React from "react";
var _obj;
export var IMAGE_URLS = (_obj = {}, _define_property(_obj, OwFGrantApplicationSteps.STORE_DETAILS_INTRO, "https://cdn.faire.com/fastly/858334a6caf3751d8db1c2906085296c8b8f9a4d11f8309dbc59346dcd93ab77.jpeg"), _define_property(_obj, OwFGrantApplicationSteps.FINANCIAL_DETAILS_INTRO, "https://cdn.faire.com/fastly/4036f702c844bfc341dc30a5d96a2ff8185ec89bc48bc0d37f11a6c1bac1e7c6.jpeg"), _define_property(_obj, OwFGrantApplicationSteps.VIDEO_UPLOAD_INTRO, "https://cdn.faire.com/fastly/024f18ce8ba5c6e12da036cdc101353e45808dc8225e7a3aafce90cf0a2fcade.jpeg"), _obj);
export var getFormattedGrantMoney = function() {
    return formatMoney({
        money: getSettingOwFGrantMoney(),
        roundingStrategy: RoundingStrategy.DROP_CENTS,
        disableAutoConvertCurrency: true
    });
};
export var TosLinkFormatting = function(color) {
    return function TosLinkFormatting(chunks) {
        return /*#__PURE__*/ _jsx(Button, {
            variant: "tertiary",
            target: "_blank",
            tertiaryColor: color,
            linkTo: smallBusinessGrantTosRoute,
            children: chunks
        });
    };
};
export var getTimelineData = function(grantDates, strictLocalize) {
    return [
        {
            date: grantDates.dueDate,
            label: strictLocalize({
                id: "UhgvHf",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Applications are due"
                    }
                ]
            }),
            description: strictLocalize({
                id: "WA/TSq",
                defaultMessage: [
                    {
                        type: 0,
                        value: "It takes just 10 minutes to apply\u2014don\u2019t miss the chance to get a grant for your new store!"
                    }
                ]
            })
        },
        {
            date: grantDates.reviewDate,
            label: strictLocalize({
                id: "0lkqph",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Applications are reviewed"
                    }
                ]
            }),
            description: strictLocalize({
                id: "4hN4zO",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Our panel of judges will carefully review each eligible submission to select the final recipients."
                    }
                ]
            })
        },
        {
            date: grantDates.announcementDate,
            label: strictLocalize({
                id: "ZnkW+I",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Recipients are announced"
                    }
                ]
            }),
            description: strictLocalize({
                id: "CAUYHb",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Join us in celebrating the recipients and their contributions to our communities."
                    }
                ]
            })
        }
    ];
};
export var HowToStep = function(param) {
    var numeration = param.numeration, headingText = param.headingText, bodyText = param.bodyText, image = param.image, smallFont = param.smallFont;
    return /*#__PURE__*/ _jsxs(Row, {
        justify: "space-between",
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: {
                            mobileAndAbove: "paragraphSansMedium",
                            desktopAndAbove: smallFont ? "subheadingSansMedium" : "sectionHeaderSansMedium"
                        },
                        children: numeration
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "2x"
                    }),
                    /*#__PURE__*/ _jsxs(Column, {
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: {
                                    mobileAndAbove: "paragraphSansMedium",
                                    desktopAndAbove: smallFont ? "subheadingSansMedium" : "sectionHeaderSansMedium"
                                },
                                children: headingText
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "1x"
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: {
                                    mobileAndAbove: "paragraphSansRegular",
                                    desktopAndAbove: smallFont ? "paragraphSansRegular" : "subheadingSansRegular"
                                },
                                children: bodyText
                            })
                        ]
                    })
                ]
            }),
            image ? /*#__PURE__*/ _jsxs(Row, {
                align: "center",
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "8x"
                    }),
                    image
                ]
            }) : null
        ]
    });
};
export var getVideoThumbnail = function(uploadedVideo, onThumbnailGeneration) {
    var _getWindow;
    var windowDocument = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.document;
    if (windowDocument && uploadedVideo) {
        var videoUrl = URL.createObjectURL(uploadedVideo);
        var video = windowDocument.createElement("video");
        video.src = videoUrl;
        video.currentTime = 1;
        var onCaptureThumbnail = function() {
            var canvas = windowDocument.createElement("canvas");
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            var context = canvas.getContext("2d");
            if (context) {
                context.drawImage(video, 0, 0, canvas.width, canvas.height);
                var thumbnailUrl = canvas.toDataURL("image/png");
                onThumbnailGeneration(thumbnailUrl);
            }
            video.removeEventListener("loadeddata", onCaptureThumbnail);
            URL.revokeObjectURL(videoUrl);
        };
        video.addEventListener("loadeddata", onCaptureThumbnail);
    }
};
